const Environment = {
    LOCALHOST: 'LOCALHOST',
    DEV: 'DEV',
    TEST: 'TEST',
    PROD: 'PROD',
};
export default Environment;
